import { useState, useEffect, useRef } from 'react';
import './index.css';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Tours from './components/Tours';
import { WhyUs, Testimonials, CTAStrip, Footer } from './components/Sections';
import { TourModal, BookingModal, SignInModal, SearchModal } from './components/Modals';
import InfoPagesModal from './components/InfoPages';
import WhatsAppButton from './components/WhatsAppButton';

export default function App() {
  // Modal state
  const [tourModal,    setTourModal]    = useState(null);  // tour object
  const [bookingModal, setBookingModal] = useState(null);  // tour object or true
  const [signInModal,  setSignInModal]  = useState(false);
  const [searchModal,  setSearchModal]  = useState(null);  // searchData object
  const [infoPageModal, setInfoPageModal] = useState(null);  // page string
  const [toast,        setToast]        = useState(null);
  const toastTimer                      = useRef(null);

  // Close all modals on Escape
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === 'Escape') {
        setTourModal(null);
        setBookingModal(null);
        setSignInModal(false);
        setSearchModal(null);
        setInfoPageModal(null);
      }
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, []);

  // Prevent body scroll when any modal open
  useEffect(() => {
    const anyOpen = tourModal || bookingModal || signInModal || searchModal || infoPageModal;
    document.body.style.overflow = anyOpen ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [tourModal, bookingModal, signInModal, searchModal, infoPageModal]);

  const showToast = (msg) => {
    clearTimeout(toastTimer.current);
    setToast(msg);
    toastTimer.current = setTimeout(() => setToast(null), 3000);
  };

  // Handler: click "Book Now" on a card → show tour detail modal
  const handleTourClick = (tour) => {
    setTourModal(tour);
  };

  // Handler: click "Book This Tour" in tour modal → show booking form
  const handleBookFromModal = (tour) => {
    setTourModal(null);
    setBookingModal(tour);
  };

  // Handler: book directly (skip detail)
  const handleDirectBook = (tour) => {
    setBookingModal(tour);
  };

  // Handler: consultation (no specific tour)
  const handleConsult = () => {
    setBookingModal(true);
  };

  // Handler: navbar Book Now or sign in
  const handleNavAction = (type) => {
    if (type === 'signin') setSignInModal(true);
    else if (type === 'book') setBookingModal(true);
    else document.getElementById('cta')?.scrollIntoView({ behavior: 'smooth' });
  };

  // Handler: hero search submit
  const handleSearch = (data) => {
    setSearchModal(data);
  };

  // Handler: search result → book
  const handleSearchBook = (tour) => {
    setSearchModal(null);
    setTourModal(tour);
  };

  return (
    <div className="app">
      {/* Visually hidden H1 for SEO */}
      <h1 style={{ position: 'absolute', width: '1px', height: '1px', padding: '0', margin: '-1px', overflow: 'hidden', clip: 'rect(0,0,0,0)', border: '0' }}>
        Next Dream Holiday | Best Travel Agent in Gandhinagar & Ahmedabad
      </h1>
      <Navbar onBookNow={handleNavAction} onOpenInfo={setInfoPageModal} />

      <Hero onSearch={handleSearch} />

      <Tours onBook={handleTourClick} />

      <WhyUs />

      <Testimonials />

      <CTAStrip onConsult={handleConsult} />

      <Footer onConsult={handleConsult} onOpenInfo={setInfoPageModal} />

      {/* ── MODALS ── */}
      {tourModal && (
        <TourModal
          tour={tourModal}
          onClose={() => setTourModal(null)}
          onBook={handleBookFromModal}
        />
      )}

      {bookingModal && (
        <BookingModal
          tour={bookingModal === true ? null : bookingModal}
          onClose={() => setBookingModal(null)}
          onSuccess={showToast}
        />
      )}

      {signInModal && (
        <SignInModal
          onClose={() => setSignInModal(false)}
          onSuccess={showToast}
        />
      )}

      {searchModal && (
        <SearchModal
          searchData={searchModal}
          onClose={() => setSearchModal(null)}
          onBook={handleSearchBook}
        />
      )}

      {infoPageModal && (
        <InfoPagesModal
          page={infoPageModal}
          onClose={() => setInfoPageModal(null)}
        />
      )}

      {/* ── WHATSAPP BUTTON ── */}
      <WhatsAppButton />

      {/* ── TOAST ── */}
      {toast && <div className="toast">{toast}</div>}
    </div>
  );
}
